// extracted by mini-css-extract-plugin
module.exports = {"lia-node-topics-count":"NodeTopicsCount_lia-node-topics-count__wET0x","lia-topics-count-text":"NodeTopicsCount_lia-topics-count-text__JX0k4"};